import React from 'react';

export default function NoAccess() {

    return (
        <>
            <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        html, body {
          height: 100%;
          font-family: Arial, sans-serif;
        }
        
        .no-access-container {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          padding: 20px;
          color: #333;
        }
        
        .card {
          background-color: lightgray;
          border-radius: 8px;
          padding: 40px 30px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          text-align: center;
          max-width: 400px;
          width: 100%;
          margin-bottom:22%;
        }
        
        .card .lock-icon {
          font-size: 3rem;
          color: #dc3545;
          margin-bottom: 20px;
        }
        
        .card h1 {
          font-size: 2rem;
          margin-bottom: 10px;
        }
        
        .card p {
          font-size: 1rem;
          margin-bottom: 20px;
          color: #555;
        }
        
        .card button {
          padding: 10px 20px;
          font-size: 1rem;
          border: none;
          border-radius: 5px;
          color: #fff;
          background-color: #5bc0de;
          border-color: #46b8da;
          cursor: pointer;  
          transition: background-color 0.3s ease;
        }
                
        .card button:hover {
          background-color: #46b8da;
        }
      `}</style>

            <div className="no-access-container">
                <div className="card">
                    <div className="lock-icon">🔒</div>
                    <h1>Access Denied</h1>
                    <p>Sorry, you don't have permission to view this page.</p>
                    <button onClick={() => window.history.length > 1
                        ? window.history.back()
                        : window.location.assign('/')}>
                        Go Back to Previous Page
                    </button>
                </div>
            </div>
        </>
    );
}